import React from 'react';

import { LinkMore } from '../button';

interface ResearchCardProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  readMore: string;
  onReadMore?: () => void;
}

const ResearchCard = (props: ResearchCardProps) => {
  return (
    <div className={classNames.container}>
      <h4 className={classNames.eyebrow}>{props.eyebrow}</h4>
      <h2 className={classNames.title}>{props.title}</h2>
      <h3 className={classNames.subtitle}>{props.subtitle}</h3>
      <LinkMore
        text="Read"
        textClassName={classNames.linkMore}
        link={props.readMore}
        onClick={props.onReadMore}
      />
    </div>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-flex-col',
    'tw-py-[40px]',
    'tw-px-[32px]',
    'xl:tw-px-[40px]',
    'tw-gap-[8px]',
    'md:tw-gap-[16px]',
    'tw-bg-white',
    'tw-rounded-[8px]',
    'tw-text-start',
  ].join(' '),
  eyebrow: ['tw-subtitle', 'tw-text-algae-700'].join(' '),
  title: ['tw-h3-emphasis'].join(' '),
  subtitle: ['tw-body1'].join(' '),
  linkMore: ['tw-link2'].join(' '),
};

export { ResearchCard };
